<template>
  <div>
    <PageHeader title="مدیریت تامین کننده" :items="pageHeaderItems" />

    <Loader v-if="loading" />
    <b-row v-else>
      <b-col>
        <div class="card">
          <Section title="اطلاعات تامین کننده">
            <div class="d-flex mb-3">
              <div class="w-100">
                <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="عنوان تامین کننده" placeholder="عنوان تامین کننده" />
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="w-50">
                <BaseText
                  inputType="number"
                  :maxlength="2000"
                  :value="model.salesPecentage"
                  @input="model.salesPecentage = $event"
                  title="درصد فروش"
                  placeholder="درصد فروش تامین کننده"
                />
              </div>
              <div class="w-50 ps-3">
                <BaseText
                  inputType="number"
                  :maxlength="2000"
                  :value="model.certificatePercentage"
                  @input="model.certificatePercentage = $event"
                  title="درصد مدرک"
                  placeholder="درصد مدرک"
                />
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="w-50">
                <BaseText :maxlength="2000" :value="model.firstSignature" @input="model.firstSignature = $event" title="امضا خط اول" placeholder="امضا خط اول" />
              </div>
              <div class="w-50 ps-3">
                <BaseText :maxlength="2000" :value="model.secondSignature" @input="model.secondSignature = $event" title="امضا خط دوم" placeholder="امضا خط دوم" />
              </div>
            </div>
            <div class="d-flex">
              <div class="w-50">
                <BaseText :maxlength="2000" :value="model.englishFirstName" @input="model.englishFirstName = $event" title="Name" placeholder="Name" />
              </div>
              <div class="w-50 ps-3">
                <BaseText :maxlength="2000" :value="model.englishLastName" @input="model.englishLastName = $event" title="Last Name" placeholder="Last Name" />
              </div>
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.englishTitle" @input="model.englishTitle = $event" title="Title" placeholder="Title" />
            </div>
            <div class="d-flex mb-3">
              <div class="w-50">
                <BaseText
                  :maxlength="2000"
                  :value="model.englishFirstSignature"
                  @input="model.englishFirstSignature = $event"
                  title="First signature"
                  placeholder="First signature"
                />
              </div>
              <div class="w-50 ps-3">
                <BaseText
                  :maxlength="2000"
                  :value="model.englishSecondSignature"
                  @input="model.englishSecondSignature = $event"
                  title="Second signature"
                  placeholder="Second signature"
                />
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="w-100">
                <PeopleInput :userId="model.userId" @update="(e) => (model.userId = e)" title="رابط" />
              </div>
            </div>
            <div class="mb-3"></div>
            <div
              v-if="!model.signatureFile"
              class="upload-photo-icon mt-3 d-flex mx-auto justify-content-center align-items-center"
              @click="(event) => (this.model.signatureFile.length ? event.preventDefault() : $refs.fileInput.click())"
            >
              <div>
                <i :class="['fas fa-cloud-upload-alt icon-size', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
                <div class="upload-text-size">عکس یا فایل امضای خود را وارد کنید</div>
              </div>
              <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
            </div>
            <div v-else class="grand-parent">
              <div class="upload-photo-parent">
                <div class="uploaded-photo">
                  <div class="remove-icon" @click="model.signatureFile = ''">
                    <i class="fa fa-times"></i>
                  </div>
                  <img class="previewImage" :src="model.signatureFile" />
                </div>
              </div>
            </div>
            <div class="mt-3">انتخاب عکس تامین کننده</div>
            <div
              v-if="!model.icon"
              class="upload-photo-icon mt-3 d-flex mx-auto justify-content-center align-items-center"
              @click="(event) => (this.model.icon.length ? event.preventDefault() : $refs.fileInput1.click())"
            >
              <div>
                <i :class="['fas fa-cloud-upload-alt icon-size', { 'fas fa-spinner fa-spin': cropperIconLoading }]"></i>
                <div class="upload-text-size">عکس تامین کننده را انتخاب کنید</div>
              </div>
              <input style="display: none" type="file" accept="image/*" @change="onIconFileSelected" ref="fileInput1" />
            </div>
            <div v-else class="grand-parent">
              <div class="upload-photo-parent">
                <div class="uploaded-photo">
                  <div class="remove-icon" @click="model.icon = ''">
                    <i class="fa fa-times"></i>
                  </div>
                  <img class="previewImage" :src="model.icon" />
                </div>
              </div>
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/skillupfaculties')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addFaculty">ثبت</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف تامین کننده اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteFaculty">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
  </div>
</template>
<script>
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import skillUpSupplierProvider from '../../../services/skillUp/suppliers'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import ImageCropper from '../../user/ImageCropper.vue'
import Section from '../../common/form/Section.vue'
import PeopleInput from '../../mooc/tech/faculties/PeopleInput.vue'
export default {
  name: 'ManageSuppliers',
  components: { PageHeader, BaseText, Toast, Loader, Section, PeopleInput },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imageCrop: { width: 400, height: 200 },
      iconCrop: { width: 180, height: 180 },
      model: {
        userId: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        title: '',
        englishTitle: '',
        firstSignature: '',
        secondSignature: '',
        englishFirstSignature: '',
        englishSecondSignature: '',
        englishFirstName: '',
        englishLastName: '',
        signatureFile: '',
        password: '',
        icon: '',
        salesPecentage: '',
        certificatePercentage: '',
      },
      message: '',
      cropperLoading: false,
      cropperIconLoading: false,
      submit: false,
      error: false,
      loading: false,

      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت تامین کننده', active: true },
      ],
    }
  },
  async mounted() {
    if (this.update) {
      this.fetchFaculty()
    }
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadImage(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    onIconFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadIcon(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    async addFaculty() {
      this.loading = true

      try {
        if (this.update) {
          this.model.id = +this.$route.params.id
          const req = await skillUpSupplierProvider.updateFaculty(this.model)
          if (req.status === 200) {
            this.$router.push('/list/skillupfaculties')
          } else {
            this.error = true
            this.message = 'ادمین گرامی کاربر مورد نظر در تامین کننده دیگری رابط می باشد مجاز به انتخاب این کاربر نمی باشید'
          }
          return false
        }
        for (const key in this.model) {
          if (!this.model[key]) {
            delete this.model[key]
          }
        }
        const req = await skillUpSupplierProvider.addFaculty(this.model)
        if (req.status === 200) {
          if (req.data.data.id === 0) {
            this.error = true
            this.message = 'لطفا اطلاعات را به درستی وارد کنید.'
            this.loading = false
            return false
          }
          this.$router.push('/list/skillupfaculties')
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.error = true
        this.message = error.response.data.message

        this.loading = false
      }
    },
    async fetchFaculty() {
      this.loading = true
      try {
        const req = await skillUpSupplierProvider.getFaculty(+this.$route.params.id)
        this.model = req.data.data.output
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.model.signatureFile = req.data.data.downloadUrl
      this.cropperLoading = false
    },
    async uploadIcon(e) {
      this.cropperIconLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.model.icon = req.data.data.downloadUrl
      this.cropperIconLoading = false
    },
    async deleteFaculty() {
      this.loading = true
      try {
        const req = await skillUpSupplierProvider.deleteFaculty(+this.$route.params.id)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          this.$router.push('/list/skillupfaculties' + localStorage.getItem('query'))
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 1rem;
}

.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}

::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .b-form-tags-button {
  display: none;
}
.part {
  display: inline-flex;
  width: 50%;
}
</style>
